export default {
    cancel: 'Cancel',
    close: 'Close',
    ok: 'Ok',
}
